import { API_URL } from "@data/GlobalData.js";
const GUID = await import("@asyncImports/GUID.js").then((mod) => mod.GUID);
const FileUpload = await import("@asyncImports/FileUpload.js").then(
  (mod) => mod.FileUpload,
);
const Base64toBlob = await import("@asyncImports/Base64toBlob.js").then(
  (mod) => mod.Base64toBlob,
);
const GetContentTypeByFileName =
  await import("@asyncImports/GetContentTypeByFileName.js").then(
    (mod) => mod.GetContentTypeByFileName,
  );

export const UploadFile = (
  blobFile,
  folder,
  fileName,
  postEvt,
  headers = {},
) => {
  const FileData = GUID();
  if (blobFile && fileName) {
    const data = {
      blobFile:
        blobFile instanceof Blob
          ? blobFile
          : Base64toBlob(
              blobFile.substring(blobFile.indexOf(",") + 1),
              GetContentTypeByFileName(fileName).split("/")[0],
              fileName,
            ),
      fileName,
    };
    FileUpload(
      [API_URL, "UploadFile/", fileName, "/", folder].join(""),
      data,
      FileData,
      postEvt,
      headers,
    );
  }
};
